import React, { useState, useRef } from "react";

import {
  CCollapse,
  CFormGroup,
  CLabel,
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CBadge,
  CCardHeader
} from "@coreui/react";
import moment from "moment";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

// import StatisticsAccessFilter from "../../../components/Statistics/StatisticsAccess/StatisticsAccessFilter";

import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import {
  arrayToCSV,
  elementToPDF,
  arrayToXLSX,
  arrayToXLS
} from "../../../../utils/export";
import Loading from "../../../Loading";
import ModalContentDetails from "../ModalContentDetails";
import StatisticsCurriculumFilter from "../StatisticCurriculumFilter";

import "./styles.css";
// import { set } from "core-js/library/fn/dict";

const getPercentage = plans => {
  const total = plans.reduce((acc, plan) => acc + plan.dates.length, 0);
  const executed = plans.reduce(
    (acc, plan) =>
      acc + plan.dates.filter(date => date.executions.length > 0).length,
    0
  );

  if (total === 0) return "0.00";

  return ((executed / total) * 100).toFixed(2);
};

const PageCurriculum = ({
  applications,
  user,
  activity_id: activityId,
  printStatistic
}) => {
  const token = useSelector(state => state.user.token);
  const roleType = useSelector(state => state.general.active_roles.type);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [roomId, setRoomId] = useState(0);
  const [roleId, setRoleId] = useState(0);

  const [tableGroupSelected, setTableGroupSelected] = useState([]);
  const [tableRegionSelected, setTableRegionSelected] = useState([]);
  const [tableSchoolSelected, setTableSchoolSelected] = useState([]);
  const [tableRoomSelected, setTableRoomSelected] = useState([]);
  const [collapses, setCollapse] = useState([]);
  const [initialDay, setInitialDay] = useState();
  const [finalDay, setFinalDay] = useState();
  const [initialMonth, setInitialMonth] = useState();
  const [finalMonth, setFinalMonth] = useState();

  const [typePeriod, setTypePeriod] = useState("day");

  const [pageLoading, setPageLoading] = useState(false);

  const [data, setData] = useState(null);
  const [modal, setModal] = useState(false);
  const [contentDetails, setContentDetails] = useState(false);

  const table = useRef(null);

  const changeFilter = selected => {
    setRoomId(selected.roomId);
    setRoleId(selected.roleId);
    setGroupId(selected.groupId);
    setRegionId(selected.regionId);
    setSchoolId(selected.schoolId);
  };

  const onSearch = async props => {
    if (!props.group_id) {
      toastr.warning("Atenção", "Escolha um grupo");
      return;
    }

    if (!props.serie_id) {
      toastr.warning("Atenção", "Escolha uma série");
      return;
    }

    if (!props.discipline_id) {
      toastr.warning("Atenção", "Escolha uma disciplina");
      return;
    }

    setPageLoading(true);

    try {
      const res = await axios.get(`${URL.api}statistics/curriculum_report`, {
        params: { ...props, me: roleType === "P" ? true : undefined },
        headers: { authorization: `Bearer ${token}` }
      });

      setData(res.data.data);

      setPageLoading(false);
    } catch (err) {
      toastr.error("Falha", "Não foi possível obter o relatório");
      setPageLoading(false);
    }
  };

  const onTypePeriodDay = () => {
    setTypePeriod("day");
  };

  const onTypePeriodMonth = () => {
    setTypePeriod("month");
  };

  const handleInitialDay = event => {
    setInitialDay(event.target.value);
  };

  const handleFinalDay = event => {
    setFinalDay(event.target.value);
  };

  const handleInitialMonth = event => {
    setInitialMonth(event.target.value);
  };

  const handleFinalMonth = event => {
    setFinalMonth(event.target.value);
  };

  const handleGroupSelected = id => {
    let index = tableGroupSelected.indexOf(id);
    if (index !== -1) {
      setTableGroupSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableGroupSelected(newArray => [...newArray, id]);
    }
  };

  const handleRegionSelected = id => {
    let index = tableRegionSelected.indexOf(id);
    if (index !== -1) {
      setTableRegionSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableRegionSelected(newArray => [...newArray, id]);
    }
  };

  const handleSchoolSelected = id => {
    let index = tableSchoolSelected.indexOf(id);
    if (index !== -1) {
      setTableSchoolSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableSchoolSelected(newArray => [...newArray, id]);
    }
  };

  const handleRoomSelected = id => {
    let index = tableRoomSelected.indexOf(id);
    if (index !== -1) {
      setTableRoomSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableRoomSelected(newArray => [...newArray, id]);
    }
  };

  const showModal = (e, group = 0, region = 0, school = 0, room = 0) => {
    e.stopPropagation();

    setContentDetails({
      group_id: groupId || group,
      region_id: regionId || region,
      school_id: schoolId || school,
      room_id: roomId || room,
      role_id: roleId,
      period: typePeriod,
      start: typePeriod === "day" ? initialDay : initialMonth,
      end: typePeriod === "day" ? finalDay : finalMonth
    });

    setModal(true);
  };

  const getArrayCSV = data => {
    const header = [
      "tipo_de_unidade",
      "nome",
      "quantidade_usuarios",
      "quantidade_acessantes",
      "percentual_acessantes",
      "quantidade_acessos",
      "quantidade_conteudos",
      "quantidade_conteudos_acessados",
      "percentual_conteudos_acessados",
      "quantidade_acessos_conteudos"
    ];

    const arr = [header];

    data.forEach(group => {
      arr.push([
        "grupo",
        group.name,
        group.users,
        group.accessors,
        group.users_accessors,
        group.accesses,
        group.contents,
        group.accessed_contents,
        group.contents_accessed_contents,
        group.accesses_content
      ]);

      group.regions.forEach(region => {
        arr.push([
          "regional",
          region.name,
          region.users,
          region.accessors,
          region.users_accessors,
          region.accesses,
          region.contents,
          region.accessed_contents,
          region.contents_accessed_contents,
          region.accesses_content
        ]);

        region.schools.forEach(school => {
          arr.push([
            "escola",
            school.name,
            school.users,
            school.accessors,
            school.users_accessors,
            school.accesses,
            school.contents,
            school.accessed_contents,
            school.contents_accessed_contents,
            school.accesses_content
          ]);

          school.rooms.forEach(room => {
            arr.push([
              "turma",
              room.name,
              room.users,
              room.accessors,
              room.users_accessors,
              room.accesses,
              room.contents,
              room.accessed_contents,
              room.contents_accessed_contents,
              room.accesses_content
            ]);
          });
        });
      });
    });

    return arr;
  };
  const getPlans = data => {
    const plans = data.plans;
    if (plans.length < 1) return "";
    const plansWithData = plans
      .filter(e => e.dates.length > 0)
      .map(e => ({
        dates: e.dates.map(o => {
          const currentDate = moment();
          const date = moment(o.date);
          const formatedDate = date.format("DD/MM/YYYY");
          const formatedExecutions = o.executions?.map(exec => {
            const effectiveFormated = moment(exec.effective_date).format(
              "DD/MM/YYYY"
            );
            return { date: effectiveFormated };
          });
          let status = "Ministrada";
          if (formatedExecutions.length < 1) {
            if (date.isBefore(currentDate)) status = "Não ministrada";
            else status = "Prevista";
          }
          return {
            date: formatedDate,
            executions: formatedExecutions,
            status,
            methods: e.methods,
            resources: e.resources
          };
        })
      }));

    return plansWithData;
  };
  const getStatusColors = status => {
    switch (status) {
      case "Não ministrada":
        return "danger";
      case "Ministrada":
        return "success";
      case "Prevista":
        return "warning";
      default:
        return "dark";
    }
  };

  const getArray = data => {
    const header = ["id", "código", "descrição", "porcentagem"];

    const arr = [header];

    data.forEach((item, index) => {
      item.curricula.forEach(ability => {
        arr.push([
          ability.id,
          ability.code,
          ability.ability.description,
          `${getPercentage(ability.plans)}%`
        ]);
      });
    });

    return arr;
  };

  return (
    <>
      {modal && (
        <ModalContentDetails
          show
          filter={contentDetails}
          onClose={() => setModal(false)}
        />
      )}
      <div className="d-flex flex-column align-items-left">
        <CCard>
          <CCardBody>
            <StatisticsCurriculumFilter onSearch={onSearch} />
          </CCardBody>
        </CCard>
        {pageLoading ? (
          <div className="w-100 p-5 text-muted justify-content-center d-flex text-center">
            <Loading />
          </div>
        ) : !data ? (
          <div className="w-100 p-5 text-muted justify-content-center d-flex text-center">
            Preencha os filtros para obter o relatório de currículo
          </div>
        ) : data.length === 0 ? (
          <div className="w-100 p-5 text-muted justify-content-center d-flex text-center">
            Nada encontrado
          </div>
        ) : (
          <div className="w-100">
            {data.map(period => (
              <>
                <div className="d-flex w-100 justify-content-end mt-3 mb-2">
                  <CButton
                    id="printBtn"
                    color="link"
                    className="text-muted p-0"
                    size="sm"
                    onClick={() =>
                      arrayToXLSX(getArray(data), "Relatório de Currículo.xlsx")
                    }
                  >
                    <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para
                    XLSX
                  </CButton>
                  <span className="mx-2">|</span>
                  <CButton
                    id="printBtn"
                    color="link"
                    className="text-muted p-0"
                    size="sm"
                    onClick={() =>
                      arrayToXLS(getArray(data), "Relatório de Currículo.xls")
                    }
                  >
                    <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLS
                  </CButton>
                  <span className="mx-2">|</span>
                  <CButton
                    id="printBtn"
                    color="link"
                    className="text-muted p-0"
                    size="sm"
                    onClick={() =>
                      arrayToCSV(getArray(data), "Relatório de Currículo.csv")
                    }
                  >
                    <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para CSV
                  </CButton>
                  <span className="mx-2">|</span>
                  <CButton
                    id="printBtn"
                    color="link"
                    className="text-muted p-0"
                    size="sm"
                    onClick={() =>
                      elementToPDF("list", "Relatório de Currículo.pdf")
                    }
                  >
                    <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
                  </CButton>
                </div>
                <div key={period.id} className="w-100">
                  <strong>{period.description}</strong>
                  <div className="d-flex flex-column align-items-left">
                    {period.curricula.map(curriculum => {
                      const plans = getPlans(curriculum);
                      return (
                        <CCard
                          key={curriculum.id}
                          className="card"
                          style={{ borderLeft: "4px solid var(--light)" }}
                        >
                          <CCardHeader>
                            <h3>{curriculum.code}</h3>
                            <h5>({getPercentage(curriculum.plans)}%)</h5>
                          </CCardHeader>
                          <CCardBody>
                            {curriculum.ability?.description || "-"}
                          </CCardBody>
                          <CCardFooter className="d-flex flex-column justify-content-start pb-0">
                            {Array.isArray(plans) ? (
                              <CFormGroup className="" key={curriculum.id}>
                                <div
                                  className="d-flex align-items-center justify-content-between w-100"
                                  style={{ cursor: "pointer" }}
                                  onMouseDown={() =>
                                    setCollapse(
                                      collapses.includes(curriculum.id)
                                        ? [
                                            ...collapses.filter(
                                              e => e !== curriculum.id
                                            )
                                          ]
                                        : [curriculum.id, ...collapses]
                                    )
                                  }
                                >
                                  <CLabel
                                    className="m-0"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <strong>Ver planos</strong>
                                  </CLabel>
                                  <i className="text-muted activity-collapse fa fa-chevron-down pointer cursor-pointer"></i>
                                </div>
                                <CCollapse
                                  show={collapses?.includes(curriculum.id)}
                                >
                                  <div className="p-2 m-1">
                                    {plans.map((item, index) =>
                                      item.dates.map((dataItem, dataIndex) => (
                                        <div
                                          key={`${index}-${dataIndex}`}
                                          className="w-100 pl-2 mt-3"
                                          style={{
                                            borderLeft: "4px solid var(--light)"
                                          }}
                                        >
                                          <div className="cards-activity-item">
                                            <div
                                              className="d-flex flex-column justify-content-center"
                                              style={{ flex: "1 1 0%" }}
                                            >
                                              <div
                                                className="cards-activity-title"
                                                style={{ fontSize: "1.2em" }}
                                              >
                                                {dataItem.date}{" "}
                                                <CBadge
                                                  className="p-2"
                                                  color={getStatusColors(
                                                    dataItem.status
                                                  )}
                                                >
                                                  {dataItem.status}
                                                </CBadge>
                                              </div>
                                              <div>
                                                <b>Métodos utilizados:</b>
                                              </div>
                                              <div>
                                                {dataItem.methods.length > 0
                                                  ? dataItem.methods?.map(
                                                      method => (
                                                        <span className="small text-muted">
                                                          {
                                                            method.method
                                                              ?.description
                                                          }
                                                        </span>
                                                      )
                                                    )
                                                  : "N/A"}
                                              </div>
                                              <div>
                                                <b>Recursos utilizados:</b>
                                              </div>
                                              <div>
                                                {dataItem.resources.length > 0
                                                  ? dataItem.resources?.map(
                                                      resource => (
                                                        <span className="small text-muted">
                                                          {
                                                            resource.resource
                                                              ?.description
                                                          }
                                                        </span>
                                                      )
                                                    )
                                                  : "N/A"}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    )}
                                  </div>
                                </CCollapse>
                              </CFormGroup>
                            ) : (
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <p>Nenhum plano encontrado.</p>
                              </div>
                            )}
                          </CCardFooter>
                        </CCard>
                      );
                    })}
                  </div>

                  <div key={period.id} className="w-100" id="list">
                    <strong>{period.description}</strong>
                    <div className="d-flex flex-column align-items-left">
                      {period.curricula.map(curriculum => (
                        <div
                          key={curriculum.id}
                          className="w-100 ml-3 pl-2 mt-2"
                          style={{ borderLeft: "4px solid var(--light)" }}
                        >
                          <div className="font-weight-bold mb-1">
                            {curriculum.code}
                          </div>
                          <div className="mb-1">
                            {curriculum.ability?.description || "-"}
                          </div>
                          <div className="font-weight-bold">
                            {getPercentage(curriculum.plans)}%
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default PageCurriculum;
